{ 
let state = window.state;

const curProgress = document.getElementById("cur-progress");
const progressContain = document.querySelector(".progress-container");
const progressContent = document.getElementById("progress-content");
const progressDisplay = document.getElementById("progress-display");
const progressRestart = document.getElementById("top-restart");

const questionWrap = document.getElementById("step-container-wrapper");
const questions = document.querySelectorAll(".step-container");

const resultContainer = document.getElementById("results-container");
const resultCards = document.getElementById("results-grid");

let results = window.products;

loadPage()

function loadPage() {
    if (state.q_num < questions.length) {
        displayQuestion();
    } else {
        displayResults();
    }

    document.querySelectorAll(".total-count").forEach(count => {
        count.innerHTML = window.products.length;
    });

    filterResults();
}

function displayQuestion() {
    questions.forEach((q, i) => {
        q.style.display = (i === state.q_num) ? "grid" : "none";
    });
    progressContent.style.width = 100 * (state.q_num / questions.length) + "%";
    curProgress.innerHTML = state.q_num + 1;
    state.last_viewed = state.q_num;
}

function filterResults() {
    const filters = Object.values(state.selected_options);
    results = window.products.filter((product) => {
        return filters.every((filter) => { 
            return filter === "empty" || product.tags.includes(filter); 
        });
    });

    document.querySelectorAll(".result-count").forEach(count => {
        count.innerHTML = results.length;
    });
}

function displayResults() {
    questionWrap.style.display = "none";
    resultContainer.style.display = "block";

    resultCards.innerHTML = results.map(product => product.html).join("");
    resultCards.querySelectorAll("img").forEach((img) => {
        const dataSrc = img.getAttribute("data-src") || img.getAttribute("data-srcset");
        if (dataSrc) img.setAttribute("src", dataSrc);
        
        img.removeAttribute("loading");
        img.style.opacity = "1";
        img.style.visibility = "visible";
    });

    progressDisplay.style.display = "none";
    progressRestart.style.display = "block";
    progressContain.classList.add("results");
}

function hideResults() {
    questionWrap.style.display = "block";
    resultContainer.style.display = "none";

    progressDisplay.style.display = "block";
    progressRestart.style.display = "none";
    progressContain.classList.remove("results");
}

function removeSelected(container) {
    container.querySelectorAll(".option-btn").forEach(btn => {
        btn.classList.remove("selected");
    });
}



document.querySelectorAll(".option-btn").forEach(btn => {
    btn.addEventListener("click", event => {
        const current = event.target.closest(".option-container");
        const nav = event.target.closest(".select-container-wrapper").querySelector(".navigation");
        if (btn.classList.contains("selected")) {
            removeSelected(current);
            if (state.q_num in state.selected_options) {
                delete state.selected_options[state.q_num];
            }
            filterResults();
            if (!nav.querySelector(".next-btn").disabled) {
                nav.querySelector(".next-btn").disabled = true;
            }
        } else {
            removeSelected(current);
            btn.classList.add("selected");
            state.selected_options[state.q_num] = btn.getAttribute("data-tag");
            filterResults();
            if (nav.querySelector(".next-btn").disabled && results.length !== 0) {
                nav.querySelector(".next-btn").disabled = false;
            } else if (results.length === 0) {
                nav.querySelector(".next-btn").disabled = true;
            }
        }
    });
});

document.querySelectorAll(".next-btn").forEach(btn => {
    btn.addEventListener("click", event => {
        state.q_num++;
        if (state.q_num < questions.length) {
            displayQuestion();
        } else {
            progressContent.style.width = "100%";
            displayResults();
        }
    });
});

document.querySelectorAll(".back-btn").forEach(btn => {
    btn.addEventListener("click", (event => {
        if (state.q_num === questions.length) {
            hideResults();
            window.scrollTo(0, 0);
            state.q_num = state.last_viewed;
        } else if (state.q_num > 0) {
            delete state.selected_options[state.q_num];
            filterResults();
            removeSelected(btn.closest(".select-container-wrapper"));
            btn.closest(".navigation").querySelector(".next-btn").disabled = true;
            state.q_num--;
            state.last_viewed = state.q_num;
        }
        else { return; }
        displayQuestion();
    }));
});

document.querySelectorAll(".restart-btn").forEach(btn => {
    btn.addEventListener("click", (event => {
        state = { q_num: 0, selected_options: {}, last_viewed: 0 };
        removeSelected(document);
        document.querySelectorAll(".next-btn").forEach(btn => { btn.disabled = true; });
        hideResults();
        filterResults();
        displayQuestion();
    }));
});

document.querySelectorAll(".results-display").forEach(btn => {
    btn.addEventListener("click", event => {
        if (results.length !== 0) {
            state.q_num = questions.length;
            progressContent.style.width = "100%";
            displayResults();
        }
    });
});

}